import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("co_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const imp = localStorage.getItem("co_impersonate_ws");
  if (imp) cfg.headers["X-Impersonate-Workspace"] = imp;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";
    // Clear stale impersonation header if the workspace can't be found (or is forbidden)
    // and retry the original request ONCE without the header.
    const hadImp = err?.config?.headers?.["X-Impersonate-Workspace"];
    const alreadyRetried = err?.config?.__coRetried;
    const looksLikeStaleImp =
      hadImp &&
      !alreadyRetried &&
      (status === 404 || status === 403) &&
      /workspace/i.test(String(detail));
    if (looksLikeStaleImp) {
      localStorage.removeItem("co_impersonate_ws");
      localStorage.removeItem("co_impersonate_ws_name");
      const cfg = { ...err.config, __coRetried: true };
      if (cfg.headers) delete cfg.headers["X-Impersonate-Workspace"];
      return api.request(cfg);
    }
    if (status === 401) {
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/signup" && path !== "/") {
        localStorage.removeItem("co_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
